import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

export default function CategoryTabPanel(props){

    const { children, value, index } = props
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
      >
        {<Box p={1}>{children}</Box>}
      </Typography>
    );
}